import { useMutation, useQuery, useQueryClient } from '@tanstack/react-query';

import {
	markAllNotificationsRead,
	markNotificationRead,
	type Notification,
	notificationQueries,
} from '@/api';

import { useSession } from './use-session';

/** Лічильник для дзвіночка. Лише автентифікованому: гостю бекенд відповів би 401. */
export function useUnreadCount(): number {
	const { isAuthenticated } = useSession();
	const { data } = useQuery({ ...notificationQueries.unread(), enabled: isAuthenticated });
	return data?.unread ?? 0;
}

export function useNotifications(): { notifications: Notification[]; isPending: boolean } {
	const { isAuthenticated } = useSession();
	const { data, isPending } = useQuery({ ...notificationQueries.list(), enabled: isAuthenticated });
	return { notifications: data ?? [], isPending: isAuthenticated && isPending };
}

/**
 * Прочитання. Після нього оновлюється і список, і лічильник — ключ
 * `notificationQueries.all()` є префіксом для обох.
 */
export function useMarkRead(): { markRead: (id: string) => void; markAllRead: () => void } {
	const queryClient = useQueryClient();
	const invalidate = (): Promise<void> => queryClient.invalidateQueries({ queryKey: notificationQueries.all() });
	const one = useMutation({ mutationFn: markNotificationRead, onSettled: invalidate });
	const all = useMutation({ mutationFn: markAllNotificationsRead, onSettled: invalidate });
	return { markRead: (id) => one.mutate(id), markAllRead: () => all.mutate() };
}
